import { TagTypes } from '../../../Api/Types/tagTypes';
import { contractsApi } from './contractsApi';

const extendedContractsApi = contractsApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /contracts/{id}/pdf - Pobieranie PDF kontraktu
    getContractPdf: builder.query<Blob, number>({
      query: (id) => ({
        url: `/contract/${id}/pdf`,
        method: 'GET',
        responseHandler: async (response) => {
          if (!response.ok) {
            throw new Error('Failed to download PDF');
          }
          return response.blob();
        },
      }),
      providesTags: (result, error, id) => [{ type: TagTypes.Contract, id }],
    }),
    // GET /api/admin/contract/reservation/{reservationId}/pdf - Pobieranie PDF kontraktu na podstawie ID rezerwacji
    getContractPdfByReservation: builder.query<Blob, number>({
      query: (reservationId) => {
        const url = `/contract/reservation/${reservationId}/pdf`;
        return {
          url,
          method: 'GET',
          responseHandler: async (response) => {
            if (!response.ok) {
              throw new Error('Failed to download PDF');
            }
            return response.blob();
          },
        };
      },
      providesTags: (result, error, reservationId) => [
        { type: TagTypes.Contract, id: 'LIST' },
        { type: TagTypes.Reservation, id: reservationId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetContractPdfQuery,
  useLazyGetContractPdfQuery,
  useGetContractPdfByReservationQuery,
  useLazyGetContractPdfByReservationQuery,
} = extendedContractsApi;
